export default __webpack_public_path__ + "static/media/gallery-wip-neck_09.3924cf85.jpg";